<div class="container">
  <div class="header row">
    <h1>Admin</h1>
    <button
      class="fill"
      (click)="openNewUserDialog()"
      [disabled]="isUserListLoading"
    >
      Add User
    </button>
  </div>
  <div class="main">
    <app-tab-group [style]="'underline'">
      <app-tab label="Users"
        ><app-user-list
          [fetchUsers]="fetchUsersSubject.asObservable()"
          (isLoadingChange)="onUserListLoadingChange($event)"
      /></app-tab>
      <app-tab label="Historical" *ngIf="false"
        ><app-historical-data
      /></app-tab>
    </app-tab-group>
  </div>
</div>
